// extracted by mini-css-extract-plugin
export var productImage = "_xr-0";